import Nullstack from 'nullstack';
export default function IconShare({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-share",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "6",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "3"
  }), "   ", Nullstack.element("line", {
    x1: "8.7",
    y1: "10.7",
    x2: "15.3",
    y2: "7.3"
  }), "   ", Nullstack.element("line", {
    x1: "8.7",
    y1: "13.3",
    x2: "15.3",
    y2: "16.7"
  }), " ");
}